import Scrollbar, { ScrollbarPlugin } from 'smooth-scrollbar';
import gsap from 'gsap';
import { ScrollTrigger} from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";


export default () =>{
	class ModalPlugin extends ScrollbarPlugin {
		static pluginName = 'modal';
	
		static defaultOptions = {
			open: false
		};
	
		transformDelta(delta) {
			return this.options.open ? { x: 0, y: 0 } : delta;
		}
	}
	
	Scrollbar.use(ModalPlugin, /* OverscrollPlugin */);
	gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
	let scrollbarContainer = document.querySelector('.scroll-container');
    document.querySelector('.scroll-container').style.opacity = 1;
	const headerHeight = document.querySelector('.header').offsetHeight;	
	const filter = document.querySelector('.postcards-filter');
	const scrollbar = Scrollbar.init(scrollbarContainer, {
		alwaysShowTracks:false,
		damping: 0.05,
		syncCallbacks: true,
		continuousScrolling: false,
		delegateTo: document
	});
	if (filter) {const scroll2 = Scrollbar.init(filter)}
	
	scrollbar.track.xAxis.element.remove();
	ScrollTrigger.scrollerProxy(document.body, {
		scrollTop(value) {
			if (arguments.length) {
				scrollbar.scrollTop = value;
			}
			return scrollbar.scrollTop;
		},
		getBoundingClientRect() {
			return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
		}
	});
			
	// update ScrollTrigger when scrollbar updates
	
	
	document.querySelectorAll('.scroll-to').forEach(anchor => {
		const anchorHref = anchor.dataset.href;
		const target = document.querySelector(anchorHref)

		anchor.addEventListener('click', ()=>{
			scrollbar.update();
			scrollTo(target)
		})
	});

	
	function scrollTo(target){
		
		scrollbar.scrollIntoView(target, {
			offsetTop: -scrollbar.containerEl.scrollTop + headerHeight,
		});
	}


	// On Button click to scroll to top

	const scrollToTop = document.querySelector('#back-to-top');
	
    scrollToTop.addEventListener('click', e => {
		e.preventDefault();	
		
		scrollbar.scrollTo(0,0,600);	
    });


// Function to show the button Go to Top on 70% height on the page

	  scrollbar.addListener((status) => {
		  
		  const scrollToTopBTN = document.querySelector('.back-to-top');
		  const size = scrollbar.getSize().content.height;
		  const percent = (70 / 100) * size;
	
		  
		  if(status.offset.y > percent){
		  	scrollToTopBTN.style.display = 'flex';
		  }else{
		  	scrollToTopBTN.style.display = 'none';
		  }
	  });
	


	scrollbar.addListener(ScrollTrigger.update);
	
}

	